import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Popconfirm,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { Auth, CompanyTypes, TiepSchemaTypes } from "_helpers";
import { companyService, currencyService, companyCategoryService } from "_services";

import TabMenu from "./TabMenu";

function Summary({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [company, setCompany] = useState({});
  const [currencies, setCurrencies] = useState([]);
  const [categories, setCategories] = useState([]);

  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    setIsLoading(true);
    companyService
      .getById(id)
      .then((x) => {
        setIsLoading(false);
        setCompany(x.content);
        onFill(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
    getCurrencies();
    getCategories();
  }, []);

  const getCategories = () => {
    setIsLoading(true);
    companyCategoryService
      .getSuggestion()
      .then((x) => {
        setIsLoading(false);
        setCategories(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };


  const getCurrencies = () => {
    setIsLoading(true);
    currencyService
      .getSuggestion()
      .then((x) => {
        setIsLoading(false);
        setCurrencies(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        const payload = {
          ...values,
          companyCategories:
            values.companyCategories?.map((id) => ({ id })) || [],
        };
        companyService
          .update(id, payload)
          .then(() => {
            message.success("Successfully updated!");
            setIsLoading(false);
            history.push(`${path}`);
          })
          .catch((error) => {
            setIsLoading(false);
            message.error(`${error}`);
          });

      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const onFill = (data) => {
    const formattedData = {
      ...data,
      companyCategories: data.companyCategories?.map((c) => c.id) || [],
    };
    form.setFieldsValue(formattedData);
  };


  const onCancel = () => {
    history.push("/companies");
  };

  const getActionButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Popconfirm
          title="Are you sure to update the changes?"
          onConfirm={handleFormSumbit}
        >
          <Button key="1" type="primary" htmlType="submit" loading={isLoading}>
            Save
          </Button>
        </Popconfirm>
      );
    }
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/companies">Company Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`.replace(":id", id)}>
                Company: {company.code}
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <TabMenu menu="summary" id={id} />
          <Form
            form={form}
            name="form-create"
            layout="vertical"
            requiredMark={false}
          >
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name="importerNo"
                  label="TIN Number"
                  rules={[
                    { required: false, message: "TIN Number is required" },
                  ]}
                >
                  <Input
                    placeholder="TIN Number"
                    disabled={!Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="vatNo"
                  label="VAT Number"
                  rules={[
                    { required: false, message: "VAT Number is required" },
                  ]}
                >
                  <Input
                    placeholder="VAT Number"
                    disabled={!Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="tiepApprovalNo"
                  label="Warehouse Code"
                  rules={[{ required: false, message: "Warehouse Code" }]}
                >
                  <Input
                    placeholder="Name"
                    disabled={!Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={["tiepSchemeType"]} label="TIEP Schema Type">
                  <Select placeholder="Select TIEP Schema Type" allowClear>
                    {TiepSchemaTypes.map((type) => (
                      <Option value={type.value} key={type.value}>
                        {type.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name="companyType"
                  label="Type"
                  rules={[
                    { required: true, message: "Company type is required" },
                  ]}
                >
                  <Select
                    placeholder="Please select"
                    disabled={!Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])}
                  >
                    {CompanyTypes.map((t) => (
                      <Option value={t.value} key={t.value}>
                        {t.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="code"
                  label="Code"
                  rules={[{ required: true, message: "Code is required" }]}
                >
                  <Input
                    placeholder="Code"
                    disabled={!Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[{ required: true, message: "Name is required" }]}
                >
                  <Input
                    placeholder="Name"
                    disabled={!Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item name="companyCategories" label="Company Categories">
                  <Select
                    mode="multiple"
                    placeholder="Select Company Categories"
                    allowClear
                    disabled={!Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])}
                  >
                    {categories.map((c) => (
                      <Option value={c.id} key={c.id}>
                        {c.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name={["currency", "id"]}
                  label="Currency"
                  rules={[{ required: false, message: "Currency is required" }]}
                >
                  <Select placeholder="Please select" allowClear>
                    {currencies.length > 0 &&
                      currencies.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="emails"
                  label="Emails"
                  rules={[{ required: true, message: "Emails are required" }]}
                >
                  <Input
                    placeholder="Emails"
                    disabled={!Auth.hasRole(Auth.getProfile(), ["SAU"])}
                  />
                </Form.Item>
              </Col>
            </Row>

          </Form>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Summary;
